function copyTextWithExecCommand(text: string): boolean {
	const doc = globalThis.document;
	const textarea = doc.createElement('textarea');

	textarea.value = text;
	textarea.setAttribute('readonly', '');
	textarea.style.position = 'fixed';
	textarea.style.top = '0';
	textarea.style.left = '0';
	textarea.style.width = '1px';
	textarea.style.height = '1px';
	textarea.style.opacity = '0';
	textarea.style.pointerEvents = 'none';

	doc.body.appendChild(textarea);
	textarea.focus();
	textarea.select();
	textarea.setSelectionRange(0, text.length);

	let copied = false;
	try {
		copied = doc.execCommand('copy');
	} catch {
		copied = false;
	}

	doc.body.removeChild(textarea);
	return copied;
}

/** Копирует текст в буфер; execCommand вызывается синхронно — важно для iOS Safari. */
export async function copyTextToClipboard(text: string): Promise<boolean> {
	if (copyTextWithExecCommand(text)) {
		return true;
	}

	if (globalThis.navigator.clipboard?.writeText) {
		try {
			await globalThis.navigator.clipboard.writeText(text);
			return true;
		} catch {
			return false;
		}
	}

	return false;
}
